import React from "react";
import { HStack, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverHeader, PopoverTrigger, Text } from "@chakra-ui/react";
import { color } from "../../utils/theme";
import { InfoIcon } from "@chakra-ui/icons";



interface StepHeaderProps {
    title: string;
    description: string;
    info?: React.ReactNode;
    showInfo?: boolean;

}
const StepHeader = ({  title, description, info, showInfo }:StepHeaderProps) => {  
return (
  <HStack
    flex={0.1}
    py={4}
    w={"full"}
    display={"flex"}
    justifyContent={"space-between"}
    alignContent={"space-between"}
    borderWidth={0.5}
    px={5}
    borderRadius={2}
  >
    <Text
      flex={0.5}
      textAlign={"left"}
      fontSize={"x-large"}
      fontFamily={"sans-serif"}
      color={color.primary}
    >
      {title}
    </Text>
    <Text flex={showInfo ? 0.5 : 1} textAlign={showInfo ? "justify" : "right"} color={color.text} fontWeight={"400"}>
      {description}
    </Text>
    {info && (
      <Popover
        placement={"left-start"}
        size={"lg"}>
        <PopoverTrigger>
          <InfoIcon w={5} h={5} color={color.primary} />
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
           <PopoverHeader>Information</PopoverHeader> 
          <PopoverBody>{info}</PopoverBody>
        </PopoverContent>
      </Popover>
    )}
  </HStack>
);

};

export default StepHeader;